import Segment from '@/app/users/tracking/segment.js'
import { Google, Facebook } from '@/app/users/tracking/index.js'

const satismeterOnly =
{
  integrations: {
    SatisMeter: true,
    All: false,
  },
}

export default {
  /**
   * Tracking button clicked on footer navigation
   *
   * @param {string} currentPageUrl
   * @param {string} buttonAction
   */
  onboardingWizardFooterClick(currentPageUrl, buttonAction) {
    Segment.track('Onboarding Wizard - Footer Navigation - Button Clicked ', {
      'Current Page Url': currentPageUrl,
      'Button Clicked': buttonAction,
    })
  },

  /**
   * Tracking information about Your Details Form
   * @param {string|number} userId
   * @param {string} userEmail
   * @param {Object} volumeSelectedBucket - The bucket selected by user
   * @param {string} volumeSelectedBucket.id
   * @param {number} volumeSelectedBucket.lowestVolume
   * @param {string} volumeSelectedBucket.eventName
   * @param {string} completionTime
   */
  onboardingWizardYourDetailsSubmitted(userId, userEmail, volumeSelectedBucket, completionTime) {
    Segment.track('Onboarding Wizard - Your Details - Successful Submit', {
      'Completion Time': completionTime + ' seconds',
    })

    Segment.track('Onboarding Wizard - ' + volumeSelectedBucket.eventName, {
      'Bucket copy': volumeSelectedBucket.id,
      'Shipping volume': volumeSelectedBucket.lowestVolume,
      'Email': userEmail,
    })

    Facebook.trackCustomEvent('Onboarding Wizard - ' + volumeSelectedBucket.eventName, {
      'Bucket copy': volumeSelectedBucket.id,
      'Shipping volume': volumeSelectedBucket.lowestVolume,
    })

    Google.trackEvent(
      'shipping_volume_selected',
      volumeSelectedBucket.eventName,
      volumeSelectedBucket.id,
      volumeSelectedBucket.lowestVolume,
    )

    // Track signups on PartnerstackJS
    /* eslint-disable no-undef */
    if (window.growsumo && userId) {
      growsumo.data = {
        ...growsumo.data,
        name: userId,
        email: userId + '@sendcloud.com',
        customer_key: String(userId),
      }
      growsumo.createSignup()
    }
  },

  /**
   * Tracking information about Frontend Errors in Your Details Form
   *
   * @param {string} errorMessage
   */

  onboardingWizardYourDetailsFrontEndErrors(errorMessage) {
    Segment.track('Onboarding Wizard - Your Details - Frontend Errors Messages', {
      Errors: errorMessage,
    })
  },

  /**
   * Tracking information about Errors in Your Details Form
   *
   * @param {string} errorMessage
   */
  onboardingWizardYourDetailsBackendErrors(errorMessage) {
    Segment.track('Onboarding Wizard - Your Details - Backend Errors Messages', {
      Errors: errorMessage,
    })
  },

  /**
   * % of completion of the Wizard for each user
   * @param {string} percentage
   * @param {string} stepId
   *@param {object} stepsCompleted
   */
  onboardingWizardStepCompleted(percentage, stepId, stepsCompleted) {
    Segment.track('Onboarding Wizard - Steps Completed and percentage ', {
      '% of Steps Completed': percentage,
      'Step Completed': stepId,
      'Total Steps Completed': stepsCompleted,
    })
  },

  /**
   * Click on Get in Touch Help Link
   */
  onboardingWizardGetInTouch() {
    Segment.track('Onboarding Wizard - Help Link Top Bar - button clicked', {})
  },

  /**
   * Click on Go to the Help Center OR Academy
   * @param {string} currentPageUrl
   * @param {string | undefined} helpLinkUrl
   */
  onboardingWizardGoToTheHelpCenterOrAcademy(currentPageUrl, helpLinkUrl) {
    Segment.track('Onboarding Wizard - Go to the Help Center OR Academy -- button clicked', {
      'Current Page Url': currentPageUrl,
      'Link Destination Url': helpLinkUrl,
    })
  },

  /**
   * Create Brand Submitted Errors
   * @param {object} errors
   */
  onboardingWizardBrandErrors(errors) {
    Segment.track('Onboarding Wizard - Create Brand -- error submitted', {
      'Errors frontend and backend': errors,
    })
  },

  /**
   * Click on Go to the Help Center OR Academy
   * @param {string} destinationPage
   */
  async onboardingWizardExitedThroughModal(destinationPage) {
    Segment.track('Onboarding Wizard - Exited Through the Completed Step Modal', {
      destination_page: destinationPage,
    })
  },

  /**
   * TODO: delete after the MANDATORY_DATA_COLLECTION_OW_EXPERIMENT_ID experiment is over
   * The user decided not to connect an integration saying that they don't have a store
   */
  async onboardingWizardClaimedThatHasNoIntegration() {
    Segment.track('Onboarding Wizard (a/b test event) - Claimed that has no store')
  },

  /**
   * User complete the onboarding wizard
   */
  onboardingWizardCompleted() {
    Segment.track('Onboarding Wizard - Completed ', {}, satismeterOnly)
  },

  /**
   * User click on video carriers page experiment
   */
  onboardingWizardCarrierVideo() {
    Segment.track('Onboarding Wizard (a/b test event) - Checked Carriers Video')
  },

}
